<template>
  <div class="home centered">

      <h1 class="title colord show_in_mobile">לינקיפדיה</h1>
      <div id="lp_head">
        <h1 class="title colord show_in_desktop">לינקיפדיה</h1>
        
        <div id="search_filters">
          <input id="search" type="search" @input="handleSearch"  placeholder="חיפוש חופשי">
          
            <select v-model="filter.genre">
              <option value="">בחר סגנון</option>
              <option v-for="genre in $store.genres" :key="genre.id" :value="genre.id" >{{genre.name}}</option>
            </select>

            <!-- <md-field>
              <label for="movie">סגנון מוזיקלי</label>
              <md-select v-model="filter.genre" @md-selected="load_results">
                <md-option v-for="(item, index) in $store.genres" :key="index" > {{item}}</md-option>
              </md-select>
            </md-field> -->
          </div>
      </div>
    <div id="items_list">
      <h1 v-if="filter.q != ''">תוצאות עבור: <b v-text="filter.q"></b></h1>

      <div class="item_wrapper"  v-for="item in items" :key="item.id">
         <router-link :to="'/Artist/'+item.id"> <div class="linkipdia">
       <div class="item">
           <div class="pic" :style="'background-image:url('+ item.pic_tumb+')'"></div>
            </div>
        <h3 v-text="item.name"></h3>
     </div>
      </router-link>
      </div>
      


    </div>
      <Loader v-if="on_loading" />
    
  </div>
</template>

<script>

import Loader from '../components/loader.vue';


export default {
  components: { Loader},
  data(){
    return {

      artists: [],
      page: 0,
      filter: {
          q: '',
          genre: '',
          limit: 20,
      },     
      isSearch: false, 
      items: [],
      on_loading: false,
      searchTimer: null,
      end_results: false,
      xhr: false
    }
  },
  methods: {
    onDrop(e) {
      this.dropped.push(e.data);
    },
    handleSearch({target: {value}}){
      this.filter.q = value;
      this.isSearch = this.filter.q !== '';
      this.end_results = false;
      this.load_results();
    },
    load_results(){
     // if (this.on_loading) return;
        if (this.xhr) this.xhr.cancel();

        // if(this.filter.q === '') this.page = 0;
        this.page++;
        // if (this.page == 1) 
        // {
        //   this.items = [];
        //   this.end_results = false;
        // }

        if (this.end_results) return;

        this.on_loading = true;

        let filter = this.filter;
        filter.page = this.isSearch && filter.q != '' ? 0 : this.page;

          this.xhr = this.api({ action: 'artists/results',   data: filter, }, (data) => {
          if (data.data.items.length == 0) this.end_results = true;
          if (this.page == 1 && this.isSearch) this.items = data.data.items; 
          else {
            if (this.isSearch) this.items = data.data.items;
            else this.items.push(...data.data.items); 
          }
                    
          this.on_loading = false;
        });

    },

  },
  mounted(){
    
    this.load_results();
     window.onscroll = () => {
      if  (!this.on_loading && document.documentElement.scrollTop + 400 >= (document.body.scrollHeight - window.innerHeight ) && !this.isSearch)
			{
        this.load_results();
      }
    };
        
  },

  watch:{
    isSearch(newVal){
      if(!newVal) {
         this.page = 0;
         this.items = [];
         this.load_results();
      }
    }
  }

  
}
</script>

<style lang="scss" scoped>

.linkipdia{
    &{margin-bottom: 30px;}
    h3{text-align: center;color: #000;}
}

#items_list{
  @media (min-width: 600px) {display: grid;grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));}
  @media (max-width: 600px) {display: grid;grid-template-columns: repeat(2, 1fr);}
  .item_wrapper{width: auto;float: none;}

}

.title.colord{
  @media (max-width: 600px) {padding: 0 10px;}
  @media (min-width: 600px) {}
}

#search_filters{ display: flex; flex-direction: row; gap:10px;

 /* .md-menu.md-select{border-radius: 43.5px;border: solid 1.6px #a2a2a2;text-align: right;direction: rtl;padding-right: 20px;}*/
  input,select{width: 100%;height: 48px;  border-radius: 43px; color: #a2a2a2; padding: 0 20px; border: 1px solid #eee; outline: none; }
 /* .md-field{padding: 0;margin: 0;}
  
  .md-field label{left: unset;right: 20px;}
  .md-field.md-theme-default:after{display: none;}
  .md-field.md-theme-default::before{display: none;}
  */
}

#lp_head { display: flex;  flex-direction: row; justify-content: space-between;     align-items: center;
  @media (max-width: 600px) {justify-content: center;}
}
</style>